import { Country } from '../models/country';
import { LanguageCode } from '../models/language-code';

export class Countries {
  private readonly countries: Country[];

  constructor(flagImgPath: string) {
    // countries: all available countries in all products
    this.countries = [];

    this.countries.push({
      LanguageCode: LanguageCode.DE,
      Language: 'German',
      Name: 'Germany',
      FlagImageSrc: flagImgPath + 'de.svg',
    });

    this.countries.push({
      LanguageCode: LanguageCode.EN,
      Language: 'English',
      Name: 'England',
      FlagImageSrc: flagImgPath + 'en.svg',
    });

    // this.countries.push({
    //   Code: 'zh',
    //   Language: 'Chinese',
    //   Name: 'China',
    //   FlagImageSrc: flagImgPath + 'zh.svg',
    // });
  }

  getCountries(): Country[] {
    return this.countries;
  }

  getLanguageCodes(): LanguageCode[] {
    return this.countries.map((a) => a.LanguageCode);
  }
}
